<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form :model="groupDetail" ref="groupDetail" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <el-tabs type="border-card">
        <el-tab-pane :label="$t('message.' + langItem.langCode)" v-for="(langItem, index) in groupDetail.categoryLangMap">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <h4 class="col-sm-2 control-label">Name<span style="color:red">*</span></h4>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'categoryLangMap.' + index + '.title'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input @change="setDataToAllLang(groupDetail.categoryLangMap, 'title', langItem.title)" v-model="langItem.title" maxlength="200" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <!-- <div class="form-group">
                <h4 class="col-sm-2 control-label">Description<span style="color:red">*</span></h4>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'categoryLangMap.' + index + '.introduce'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input @change="setDataToAllLang(groupDetail.categoryLangMap, 'introduce', langItem.introduce)" type="textarea" :rows="4" v-model="langItem.introduce"></el-input>
                  </el-form-item>
                </div>
              </div> -->
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="col-sm-2" style="padding-right: 0px;">
                    <h4 style="padding-top: 20px;text-align: right;padding-right: 25px;">Home Page Image </h4>
                  </div>
                  <div class="col-sm-8" style="padding-top: 20px;padding-left: 0px;">
                    <el-form-item
                      prop="backgroundImage"
                      :rules="{
                        required: false,
                        message: $t('message.required'),
                        trigger: 'change',
                      }"
                    >
                      <!-- <el-upload v-model="groupDetail.thumbnail" action="#" list-type="picture-card" :file-list="fileList" :auto-upload="true" accept=".jpg,.png,.jpeg" :http-request="upload" :before-upload="beforeAvatarUploadImage" :on-change="handleAddFile" :before-remove="handleRemoveFile" :limit="1" ref="uploadBtn">
                              <i slot="default" class="el-icon-plus" style="margin-top: 20px">
                                <h3>Less than 10 m</h3>
                                <h3>(.png or .jpeg)</h3>
                              </i>
                            </el-upload> -->

                      <el-input v-model="groupDetail.backgroundImage" style="display: none"> </el-input>
                      <file-upload :filewidth="290" :fileheight="408" :type="'player'" :limit="30" id="image" :image="Imageurl" v-model="groupDetail.backgroundImage">
                        <template v-slot:sizeError>
                          <div style="color: red">Size error!</div>
                        </template>
                        <template v-slot:dimensionError>
                          <div style="color: red">Dimension Error!</div>
                        </template>
                        <template v-slot:sizeHint>
                          <p style=" margin-bottom: 0px;">Suggested Size: 290 x 408</p>
                          Max 30 MB.
                        </template>
                      </file-upload>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="groupDetail.homePageType == 1">
                <div class="col-sm-12">
                  <div class="col-sm-2" style="padding-right: 0px;">
                    <h4 style="padding-top: 20px;text-align: right;padding-right: 25px;">Home Page Highlight Image <span style="color:red">*</span></h4>
                  </div>
                  <div class="col-sm-8" style="padding-top: 20px;padding-left: 0px;">
                    <el-form-item
                      prop="thumbnail"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'change',
                      }"
                    >
                      <!-- <el-upload v-model="groupDetail.thumbnail" action="#" list-type="picture-card" :file-list="fileList" :auto-upload="true" accept=".jpg,.png,.jpeg" :http-request="upload" :before-upload="beforeAvatarUploadImage" :on-change="handleAddFile" :before-remove="handleRemoveFile" :limit="1" ref="uploadBtn">
                              <i slot="default" class="el-icon-plus" style="margin-top: 20px">
                                <h3>Less than 10 m</h3>
                                <h3>(.png or .jpeg)</h3>
                              </i>
                            </el-upload> -->

                      <el-input v-model="groupDetail.thumbnail" style="display: none"> </el-input>
                      <file-upload :filewidth="640" :fileheight="350" :type="'player'" :limit="30" id="image" :image="Imageurl" v-model="groupDetail.thumbnail">
                        <template v-slot:sizeError>
                          <div style="color: red">Size error!</div>
                        </template>
                        <template v-slot:dimensionError>
                          <div style="color: red">Dimension Error!</div>
                        </template>
                        <template v-slot:sizeHint>
                          <p style=" margin-bottom: 0px;">Suggested Size: 640 x 350</p>
                          Max 30 MB.
                        </template>
                      </file-upload>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <h4 class="col-sm-2 control-label">Order<span style="color:red">*</span></h4>
                <div class="col-sm-10">
                  <el-form-item
                    prop="menuSortOrder"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input-number v-model="groupDetail.menuSortOrder" :min="0" :max="998"></el-input-number>
                  </el-form-item>
                </div>
              </div>
              <div class="text-right m-b-20">
                <div>
                  <el-button @click="checkEvent">
                    Save
                  </el-button>
                </div>
              </div>
              <div v-if="$route.query.id" style="width: 100%;border-bottom: 1px solid #ccc;margin: 15px 0;"></div>
              <div class="text-right m-b-20" v-if="$route.query.id">
                <div v-if="rows.length == 0">
                  <el-button @click="addVideoEvent" type="primary" plain icon="el-icon-plus">
                    Add Video
                  </el-button>
                </div>
              </div>
              <div v-if="$route.query.id">
                <div class="col-xs-12">{{ total }}{{ $t("message.datagridresult") }}</div>
                <el-table :data="rows" sort style="width: 100%" :fit="true" border ref="multipleTable">
                  <el-table-column label="Title" prop="title" min-width="120" show-overflow-tooltip></el-table-column>

                  <el-table-column label="Date" prop="publishDate" min-width="120" show-overflow-tooltip></el-table-column>
                  <el-table-column label="Status" prop="status" min-width="80">
                    <template slot-scope="scope">
                      <span>{{ scope.row.statusName }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="Updated Time" prop="updatedTime" min-width="120" show-overflow-tooltip></el-table-column>
                  <el-table-column label="Action" width="200px" fixed="right" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-col :span="7">
                        <el-button size="mini" @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                      </el-col>
                      <el-col :span="7">
                        <el-popconfirm title="Are you sure to delete?" confirmButtonText="Yes" cancelButtonText="No" @confirm="deleteClick(scope.row)">
                          <el-button size="mini" slot="reference" icon="el-icon-delete"></el-button>
                        </el-popconfirm>
                      </el-col>
                      <el-col :span="10">
                        <el-popconfirm
                          :title="scope.row.status == 1 ? $t('message.inactiveTip') : $t('message.activeTip')"
                          confirmButtonText="Yes"
                          cancelButtonText="No"
                          @confirm="updateStatus(scope.row, 3)"
                        >
                          <el-button size="mini" :type="scope.row.status == 1 ? 'danger' : 'success'" plain slot="reference">
                            <span v-if="scope.row.status == 0">Active</span>
                            <span v-if="scope.row.status == 1">Inactive</span>
                          </el-button>
                        </el-popconfirm>
                      </el-col>
                    </template>
                  </el-table-column>
                </el-table>
                <el-col :span="24" class="el-table_footertoolbar">
                  <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pagesize"
                    :current-page="page + 1"
                    :total="total"
                    style="float:right;"
                  >
                  </el-pagination>
                </el-col>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import fileupload from "../components/common/fileupload";
export default {
  mixins: [config.globalMixin],
  components: {
    "file-upload": fileupload,
  },
  data() {
    return {
      categoryId: "",
      page: 0, //当前页数
      pagesize: 10, //一页显示几条
      total: 0,
      TypeOptions: [
        {
          value: 1,
          label: "Default Category",
        },
        {
          value: 2,
          label: "Other Category",
        },
      ],
      statusOptions: [
        {
          value: 1,
          label: "Active",
        },
        {
          value: 0,
          label: "Inactive",
        },
      ],
      ids: "",
      Imageurl: "",
      rows: [],
      showOrder: false,
      groupDetail: {
        "backgroundImage": "",
        "bannerImage": "",
        "categoryLangMap": [
          {
            "introduce": "",
            "langCode": "zh_HK",
            "name": "",
            "title": "",
          },
          {
            "introduce": "",
            "langCode": "zh_CN",
            "name": "",
            "title": "",
          },
          {
            "introduce": "",
            "langCode": "en_US",
            "name": "",
            "title": "",
          },
        ],
        "homePageType": 5,
        "layout": 1,
        "level": 2,
        "linkUrl": "anniversary",
        "menuImage": "",
        "pId": 0,
        "singleRecord": 1,
        "status": 1,
        "thumbnail": "null",
        "type": 5,
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.categoryId = this.$route.query.id;
      this.init();
    }
    this.Imageurl = this.getImgrul().url.imageUrl;
  },
  methods: {
    async init() {
      let obj = this.getAuthObj();
      obj.lang = "en_US";
      obj.apiUrl = this.apiConfig.homePageCategoryDetail + "/" + this.categoryId;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.dataResult = data.data.result;
      data.data.result.categoryLangMap = this.langMapObject(data.data.result.categoryLangMap);
      await this.categoryList(this.categoryId);
      this.$set(this, "groupDetail", data.data.result);
    },
    async saveCategory() {
      let obj = this.getAuthObj();
      this.groupDetail.categoryLangMap.forEach(item => {
        item.name = item.title;
      });
      for (var key in this.groupDetail) {
        var detail = JSON.stringify(this.groupDetail[key]);
        obj[key] = JSON.parse(detail);
      }
      obj.categoryLangMapDtos = this.groupDetail.categoryLangMap;
      delete obj.categoryLangMap;
      delete obj.parentId;
      delete obj.previewStatus;
      var data;
      if (this.$route.query.id) {
        obj.id = this.categoryId;
        obj.apiUrl = this.apiConfig.homePageCategoryUpdate;
      } else {
        obj.pId = this.$route.query.pId;
        obj.apiUrl = this.apiConfig.homePageCategoryCreate;
      }
      data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$message({
        showClose: true,
        message: "Update success",
        type: "success",
      });
      this.goBack();
    },
    goBack() {
      this.$router.push({
        path: "/main/the20thAnniversaryList",
      });
    },
    async categoryList(id) {
      let objdata = this.getAuthObj();
      objdata.maxRows = this.pagesize;
      objdata.searchBy = {
        category: this.categoryId,
        langCode: "zh_HK",
      };
      objdata.sortBy = {
        publishDate: "desc",
      };
      objdata.startRow = this.page * this.pagesize;
      objdata.apiUrl = this.apiConfig.homPageCategoryVideoList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      let list = null;
      for (list of data.data.resultList) {
        if (list.status == 1) {
          list.statusName = "Active";
        } else {
          list.statusName = "Inactive";
        }
      }
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      this.rows = data.data.resultList;
      this.total = data.data.totalRows;
    },
    checkEvent() {
      this.$refs["groupDetail"].validate(valid => {
        if (valid) {
          this.saveCategory();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    addVideoEvent() {
      this.$router.push({
        path: "/main/the20thAnniversaryVideoDetail",
        query: { cId: this.categoryId },
      });
    },
    handleDbClick: function(row) {
      this.$router.push({
        path: "/main/the20thAnniversaryVideoDetail",
        query: { id: row.id, cId: this.categoryId },
      });
    },
    async deleteClick(val) {
      let obj = this.getAuthObj();
      obj.ids = [val.id];
      obj.lang = "en_US";
      obj.apiUrl = this.apiConfig.homePageVideodelete;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (data.data.errorCode == "0000") {
        this.$message({
          showClose: true,
          message: "Delete Success",
          type: "success",
        });
        this.page = 0;
        this.init();
      }
      if (!data) return;
    },
  },
};
</script>
<style></style>
